module.exports = require("@collectivehealth/dls-icons/dist/es/elements/dls-icon-chevron-down");